import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SalesforceV2CopySourceAdapter, salesforceV2Adapts } from './salesforcev2.copysource.adapter';
import { IModel, SalesforceServiceCloudV2CopySource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudV2CopySource),
    asynchronous: true,
    adapts: salesforceV2Adapts
})
export class SalesforceServiceCloudV2CopySourceAdapter extends SalesforceV2CopySourceAdapter {
    protected override model(): IModel {
        return SalesforceServiceCloudV2CopySource.MODEL;
    }
}
